import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PlayerState {
  url: string | null;
  playing: boolean;
  callId: number | null;
  callerNumber: string;
}

const initialState: PlayerState = {
  url: null,
  playing: false,
  callId: null,
  callerNumber: '',
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    playRecording(state, action: PayloadAction<{ url: string; callId: number; callerNumber: string }>) {
      state.url = action.payload.url;
      state.callId = action.payload.callId;
      state.callerNumber = action.payload.callerNumber;
      state.playing = true;
    },
    togglePlayPause(state) {
      state.playing = !state.playing;
    },
    stopRecording() {
      return initialState;
    },
  },
});

export const { playRecording, togglePlayPause, stopRecording } = playerSlice.actions;
export default playerSlice.reducer;
